export default __webpack_public_path__ + "static/media/logo.d017e75a.png";